<template>
  <div class="my_achievement" :class="{'isiOSX1':isiOSX}">
    <van-nav-bar
      title="我的业绩"
      right-text="推广政策"
      :fixed="true"
      left-arrow
      @click-left="reBack"
      @click-right="groupRule"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <div class="my_achievement_info">
        <p class="describe">我的累计奖励积分</p>
        <p class="integral">{{memberInfo.total_reward_credits}} <span @click="rewardDetails">奖励明细<img src="../../assets/xiaobaGroup/next_1@2x.png" /></span></p>
        <p class="group" v-if="memberInfo.group && memberInfo.group.group_code">群级别Q{{memberInfo.group.group_level}} | 群代码{{memberInfo.group.group_code}}</p>
      </div>
      <p class="list_title">推广店铺列表</p>
      <div class="content">
        <van-tabs 
          v-model="active"
          swipeable
        >
          <van-tab>
            <template #title>有效商家 <span class="num">{{allList1}}</span></template>
            <van-pull-refresh v-model="isLoading1" @refresh="onRefresh1" v-if="list1">
              <van-list
                v-model="loading1"
                :finished="finished1"
                finished-text="别拉了，小巴也是有底线的"
                @load="onLoad1"
              >
                <van-row class="sales_list">
                  <van-col span="24">
                    <div class="details" v-for="(item, index) in list1" :key="index">
                      <img class="avatar" :src="item.shop_logo" @error="defaultAvatar()" />
                      <p class="shop_info">{{item.store_member_phone}} | ID {{item.store_id}}</p>
                      <p class="register_time">注册时间 {{item.created_at}}</p>
                      <p class="pay_time">保证金缴纳时间 {{item.deposit_pay_time}}</p>
                    </div>
                  </van-col>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </van-tab>
          <van-tab>
            <template #title>无效商家 <span class="num" @click.stop="openTipPupop">{{allList2}}<span>?</span></span></template>
            <van-pull-refresh v-model="isLoading2" @refresh="onRefresh2" v-if="list2">
              <van-list
                v-model="loading2"
                :finished="finished2"
                finished-text="别拉了，小巴也是有底线的"
                @load="onLoad2"
              >
                <van-row class="sales_list">
                  <van-col span="24">
                    <div class="details details_right" v-for="(item, index) in list2" :key="index">
                      <img class="avatar" :src="item.shop_logo" @error="defaultAvatar()" />
                      <p class="shop_info">{{item.store_member_phone}}</p>
                      <p class="register_time">注册时间 {{item.created_at}}</p>
                      <!--<p class="pay_time">保证金缴纳时间 {{item.deposit_pay_time}}</p>-->
                    </div>
                  </van-col>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-overlay :show="showTip">
      <div class="wrapper">
        <div class="block">
          <p class="title">温馨提示</p>
          <p class="tip">缴纳保证金的才算有效商家</p>
          <van-button class="btn" size="large" @click="closeTipPupop">我知道了</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import avatarDefault from "@/assets/common/avatar.png";
export default {
  data() {
    return {
      isiOSX: false,
      list1: [],
      loading1: false,
      finished1: false,
      isLoading1: false,
      page1: 0,
      pageSize1: 10,
      allList1: 0,
      list2: [],
      loading2: false,
      finished2: false,
      isLoading2: false,
      page2: 0,
      pageSize2: 10,
      allList2: 0,
      active: 0,
      showTip: false,
      memberInfo: {},
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.getInfo();
    // this.getReward(1, this.page1);
  },
  watch: {
    active: "tabChanged",
  },
  methods: {
    getInfo() {
      this.$api
        .get("/member-relation/member/group/recommend/reward")
        .then(res => {
          this.allList1 = res.valid_shop_count;
          this.allList2 = res.invalid_shop_count;
          this.memberInfo = res;
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    tabChanged() {
      if(this.active==1) {
        document.querySelector(".van-tabs__line").classList.add("newClass");
      }else {
        document.querySelector(".van-tabs__line").classList.remove("newClass");
      }
    },
    openTipPupop() {
      this.showTip = true;
    },
    closeTipPupop() {
      this.showTip = false;
    },
    reBack() {
      this.$router.go(-1);
    },
    groupRule() {
      this.$router.push({
        path: "/xiaobaGroup/groupRule",
        query: {
          type: 2,
          from: 1,
          token: this.$route.query.token
        }
      });
    },
    rewardDetails() {
      this.$router.push({
        path: "/xiaobaGroup/rewardDetails",
        query: {
          type: 2,
          token: this.$route.query.token
        }
      });
    },
    getReward(isValid, page) {
      this.$api
        .post("/member-relation/member/group/recommend/shop/list", {
          member_id: this.$route.query.memberId,
          is_valid: isValid,
          page: page,
        })
        .then((res) => {
          if(isValid == 1) {
            this.allList1 = res.total;
            if (res.list.length > 0) {
              for(let i in res.list) {
                this.list1.push(res.list[i]);
              }
            }
            this.loading1 = false;
            if (this.list1.length >= this.allList1) {
              // 数据全部加载完成
              this.finished1 = true;
            }
            if (this.isLoading1) {
              this.$toast("刷新成功");
              this.isLoading1 = false;
            }
          }else {
            this.allList2 = res.total;
            if (res.list.length > 0) {
              for(let i in res.list) {
                this.list2.push(res.list[i]);
              }
            }
            this.loading2 = false;
            if (this.list2.length >= this.allList2) {
              // 数据全部加载完成
              this.finished2 = true;
            }
            if (this.isLoading2) {
              this.$toast("刷新成功");
              this.isLoading2 = false;
            }
          }
        });
    },
    onLoad1() {
      // 异步更新数据
      setTimeout(() => {
        this.page1++;
        this.getReward(1, this.page1);

        // 加载状态结束
        this.isLoading1 = false;
      }, 500);
    },
    onRefresh1() {
      this.page1 = 1;
      this.finished1 = false;
      this.list1 = [];
      this.getReward(1, this.page1);
    },
    onLoad2() {
      // 异步更新数据
      setTimeout(() => {
        this.page2++;
        this.getReward(0, this.page2);

        // 加载状态结束
        this.isLoading2 = false;
      }, 500);
    },
    onRefresh2() {
      this.page2 = 1;
      this.finished2 = false;
      this.list2 = [];
      this.getReward(0, this.page2);
    },
    defaultAvatar() {
      var img = event.srcElement;
      img.src = avatarDefault;
      img.onerror = null; //防止闪图
    }
  }
};
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
  .van-tab {
    color: #333;
    padding: 0;
    height: 4.2rem;
    font-size: 1.4rem;
    text-align: left;
    width: 9.9rem;
    flex: none;
  }
  .van-tabs__line {
    width: 5.6rem !important;
    height: 0.2rem;
    bottom: 0.4rem;
    transform: translateX(5.6rem) translateX(-100%) !important;
    background: -webkit-linear-gradient(to right,#FC740C, #F41A3C); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(to right,#FC740C, #F41A3C); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(to right,#FC740C, #F41A3C); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right,#FC740C, #F41A3C); /* 标准的语法（必须放在最后） */
  }
  .newClass {
    transform: translateX(15.5rem) translateX(-100%) !important;
  }
  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border-width: 0px 0;
  }
  .van-tab {
    display: inline-block;
  }
  .van-tabs__nav--line {
    padding-bottom: 0;
  }
  .van-tab .van-tab__text {
    position: relative;
    height: 2.3rem;
    line-height: 2.3rem;
    margin-top: 1.5rem;    
    overflow: visible;
    font-weight: bold;
  }
</style>
<style lang="less" scoped>
.my_achievement {
  min-height: 100%;
  box-sizing: border-box;
  background: #F5F6F7;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #F9591B;
    overflow: hidden;
    .van-nav-bar__title {
      color: #fff;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #fff;
      font-size: 1.6rem;
      font-weight: 400;
      // padding: 0 1.2rem;
      background: #F9591B;
    }
    .van-icon {
      color: #fff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .van-hairline--top-bottom::after {
    border-width: 0 0; 
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    .my_achievement_info {
      color: #fff;
      height: 11.1rem;
      background: #F9591B;
      padding: 2.1rem 1.2rem 1.2rem;
      margin-top: -0.1rem;
      box-sizing: border-box;
      .describe {
        font-size: 1.3rem;
        height: 2.1rem;
        line-height:2.1rem;
      }
      .integral {
        font-size: 2rem;
        font-weight: bold;
        height: 3.2rem;
        line-height:3.2rem;
        span {
          font-size: 1.4rem;
          font-weight: normal;
          float: right;
          img {
            width: 1.2rem;
            display: inline-block;
          }
        }
      }
      .group {
        color: rgba(255, 255, 255, .64);
        font-size: 1.3rem;
        margin-top: 0.4rem;
        height: 2.1rem;
        line-height:2.1rem;
      }
    }
    .list_title {
      color: #999;
      font-size: 1.3rem;
      height: 2.1rem;
      line-height: 2.1rem;
      padding: 0 1.2rem;
      margin: 1.2rem 0 0.6rem;
    }
    .content {
      padding: 0 1.2rem;
      background: #fff;
      .van-tab__text {
        position: relative;
        .num {
          color: #666;
          font-size: 1.2rem;
          height: 1.9rem;
          line-height: 1.9rem;
          position: absolute;
          top: -0.3rem;
          left: 5.9rem;
          font-weight: normal;
          span {
            width: 1.8rem;
            height: 1.8rem;
            line-height: 1.8rem;
            text-align: center;
            border: solid 0.1rem #666;
            border-radius: 1.2rem;
            transform: scale(0.67);
            box-sizing: border-box;
            display: inline-block;
          }
        }
      }
      .sales_list {
        .details {
          height: 8.75rem;
          padding: 1.2rem 0 1.2rem 4.8rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;
          position: relative;
          .avatar {
            width: 3.6rem;
            height: 3.6rem;
            border-radius: 1.8rem;
            position: absolute;
            left: 0;
            top: 1.6rem;
          }
          .shop_info {
            color: #333;
            font-size: 1.4rem;
            height: 2.3rem;
            line-height: 2.3rem;
          }
          .register_time {
            color: #ccc;
            font-size: 1.1rem;
            height: 1.8rem;
            line-height: 1.8rem;
          }
          .pay_time {
            margin-top: 0.3rem;
            color: #999;
            font-size: 1.2rem;
            height: 1.9rem;
            line-height: 1.9rem;
          }
        }
        .details_right {
          height: 6.55rem;
        }
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 29.6rem;
      height: 17.5rem;
      border-radius: 1.2rem;
      padding: 2.4rem;
      background-color: #fff;
      box-sizing: border-box;
      color: #333;
      text-align: center;
      .title {
        font-size: 1.7rem;
        height: 2.8rem;
        line-height: 2.8rem;
        margin-bottom: 1.5rem;
        font-weight: bold;
      }
      .tip {
        font-size: 1.5rem;
        height: 2.4rem;
        line-height: 2.4rem;
        margin-bottom: 2.4rem;
      }
      .btn {
        color: #fff;
        font-size: 1.6rem;
        height: 3.6rem;
        line-height: 3.6rem;
        border-radius: 1.8rem;
        background: -webkit-linear-gradient(to right,#FC740C, #F41A3C); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right,#FC740C, #F41A3C); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right,#FC740C, #F41A3C); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right,#FC740C, #F41A3C); /* 标准的语法（必须放在最后） */
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
</style>


